import { cx } from '@linaria/core';
import { withSuspenseCache, useScrollDirectionClass } from '@pm2/react-utils';
import { pm2SitemapStore, findSubNavigationRoot, getRenderedDescriptorByPath } from '@pm2/sitemap-utils';
import { pm2ConfigStore } from '@pm2/store';
import { useLocation } from '@provider/navigation';
import { useUserIdentityState, userIdentityManager } from '@provider/user-identity';
import { Button } from '@ui/kit';
import { KeyIcon } from '@ui/kit/icons';
import { button, stickyHeader } from './sticky-login.style.js';
import { jsx } from 'react/jsx-runtime';
import { StickyHeader } from '../sticky-header/sticky-header.js';

function StickyLoginHeader() {
  const user = useUserIdentityState(state => state.user);
  const location = useLocation();
  const configStore = pm2ConfigStore.useStore();
  const sitemapStore = pm2SitemapStore.useStore();
  const showCourseFrontpages = pm2ConfigStore.useSelector(state => state.config.settings.showCourseFrontpages);
  const portalTitle = pm2ConfigStore.useSelector(state => state.config.title);
  const sitemapState = pm2SitemapStore.useSelector(state => state);
  const subRoot = findSubNavigationRoot(sitemapState, location.pathname);
  const currentPage = withSuspenseCache(getRenderedDescriptorByPath(configStore, sitemapStore, location.pathname));
  const heading = subRoot?.title || portalTitle;
  const subHeading = subRoot === currentPage ? undefined : currentPage?.title;
  const {
    scrolledDown,
    direction
  } = useScrollDirectionClass();
  const visible = scrolledDown && direction === "down";
  const onCourseFrontpage = currentPage?.type === "Course" && showCourseFrontpages;

  // The login header should only be enabled once we've resolved that no users
  // have been logged in.
  // Furthermore, the course frontpages ship with their own implementation of
  // the sticky login header.
  const enabled = user === null && !onCourseFrontpage;
  if (!enabled) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: cx(stickyHeader, visible && "visible"),
    children: /*#__PURE__*/jsx(StickyHeader, {
      heading: heading,
      subHeading: subHeading,
      children: /*#__PURE__*/jsx(Button, {
        className: button,
        onClick: userIdentityManager.requestLogin,
        icon: /*#__PURE__*/jsx(KeyIcon, {}),
        layout: "large",
        theme: "primary",
        children: "Log ind"
      })
    })
  });
}

export { StickyLoginHeader };
//# sourceMappingURL=sticky-login.js.map
